import axios from 'axios';

const getPriorYearScheduleLineItems = ({ companyId, priorYearItemId }) =>
  axios.get(`/prior_year_items/get_prior_year_schedule_line_items`, {
    params: {
      company_id: companyId,
      prior_year_item_id: priorYearItemId,
    },
  });

const getPriorYearScheduleLineItemsByPriorYearId = ({ priorYearItemId }) =>
  axios.get(
    `/prior_year_items/get_prior_year_schedule_line_items_by_prior_year_id`,
    {
      params: {
        prior_year_item_id: priorYearItemId,
      },
    },
  );

const getDefaultScheduleLineItems = ({ scheduleName }) =>
  axios.get(`/prior_year_items/get_default_schedule_line_items`, {
    params: {
      schedule_name: scheduleName,
    },
  });

const addPriorYearScheduleLineItem = ({
  companyId,
  priorYearItemId,
  category,
  value,
}) =>
  axios.post(
    `/prior_year_items/${priorYearItemId}/add_prior_year_schedule_line_item`,
    {
      company_id: companyId,
      category,
      value,
    },
  );

const addPriorYearScheduleLineItemWithoutCompany = ({
  priorYearItemId,
  category,
  value,
}) =>
  axios.post(
    `/prior_year_items/${priorYearItemId}/add_prior_year_schedule_line_item_without_company`,
    {
      category,
      value,
    },
  );

const deletePriorYearScheduleLineItem = ({ companyId, lineItemId }) =>
  axios.post(`/prior_year_items/delete_prior_year_schedule_line_item`, {
    line_item_id: lineItemId,
    company_id: companyId,
  });

const deletePriorYearScheduleLineItemByItemId = ({ lineItemId }) =>
  axios.post(
    `/prior_year_items/delete_prior_year_schedule_line_item_by_item_id`,
    {
      line_item_id: lineItemId,
    },
  );

const updatePriorYearScheduleLineItem = ({
  companyId,
  lineItemId,
  category,
  value,
}) =>
  axios.post(`/prior_year_items/update_prior_year_schedule_line_item`, {
    line_item_id: lineItemId,
    company_id: companyId,
    category,
    value,
  });

const updatePriorYearScheduleLineItemByItemId = ({
  lineItemId,
  category,
  value,
}) =>
  axios.post(
    `/prior_year_items/update_prior_year_schedule_line_item_by_item_id`,
    {
      line_item_id: lineItemId,
      category,
      value,
    },
  );

const getPriorYearItems = ({ companyId }) =>
  axios.get(`/prior_year_items/get_prior_year_items`, {
    params: {
      company_id: companyId,
    },
  });

const addPriorYearItem = ({ companyId, name, year }) =>
  axios.post(`/prior_year_items/add_prior_year_item`, {
    company_id: companyId,
    name,
    year,
  });

const updatePriorYearItem = ({ companyId, priorYearItemId, name, year }) =>
  axios.post(`/prior_year_items/${priorYearItemId}/update_prior_year_item`, {
    company_id: companyId,
    name,
    year,
  });

const updatePriorYearItemName = ({ priorYearItemId, name }) =>
  axios.post(
    `/prior_year_items/${priorYearItemId}/update_prior_year_item_name`,
    {
      name,
    },
  );

const deletePriorYearItem = ({ companyId, priorYearItemId }) =>
  axios.post(`/prior_year_items/${priorYearItemId}/delete_prior_year_item`, {
    company_id: companyId,
  });

const getRolloverItemsForFirm = year =>
  axios.get(`/prior_year_items/get_prior_year_item_for_firm?year=${year}`);

const rolloverToNextYear = year =>
  axios.post(`/prior_year_items/rollover_to_next_year?year=${year}`);

export default {
  getPriorYearItems,
  addPriorYearItem,
  updatePriorYearItem,
  updatePriorYearItemName,
  deletePriorYearItem,
  getPriorYearScheduleLineItems,
  getPriorYearScheduleLineItemsByPriorYearId,
  addPriorYearScheduleLineItem,
  addPriorYearScheduleLineItemWithoutCompany,
  deletePriorYearScheduleLineItem,
  deletePriorYearScheduleLineItemByItemId,
  updatePriorYearScheduleLineItem,
  updatePriorYearScheduleLineItemByItemId,
  getDefaultScheduleLineItems,
  getRolloverItemsForFirm,
  rolloverToNextYear,
};
